import { SUBSCRIPTIONS_CUSTOMER_CONTROLLER_ROOT_PATH } from "../root";

/** /customer/subscription/scoop */
export const SUBSCRIPTIONS_CUSTOMER_SCOOP_CONTROLLER_ROOT_PATH = `${
  SUBSCRIPTIONS_CUSTOMER_CONTROLLER_ROOT_PATH
}/scoop`;
